import bannerVektor from "../../../assets/images/tablet-banner-vektor.png";
import bannerLogo from "../../../assets/images/tablet-banner-logo.png";

const TabletBannerImage = () => {
  return (
    <div className="relative flex items-center justify-center">
      <img src={bannerVektor} alt="vektor" className="block" />
      <img src={bannerLogo} alt="logo" className="absolute -top-5" />
    </div>
  );
};

export default TabletBannerImage;
